module.exports = __webpack_public_path__ + "img/myred_bg.d4f985b5.png";